// Centralised permission check.
//
// Default-allow pattern: if `session.permissions[flag]` is undefined or
// not the literal `false`, the action is granted. Only an explicit
// `false` denies. Admins always bypass — `role === 'admin'` returns
// true regardless of the flag.
//
// Used by:
//   - Catalogue.jsx + CatalogueDrawer.jsx (`stock_write`)
//   - Subscriptions.jsx (`finance_subs_write`)
//   - InvoiceTracker.jsx (`finance_invoices_write`)
//   - PoTracker.jsx (`finance_pos_write`)
//   - AddressBook.jsx + ContactDrawer.jsx (`contacts_write`)
//   - App.jsx (`mo_chat`)
//
// Frontend-only check — do NOT rely on this for security. The
// authorised-write Lambda enforces role and (where applicable) the same
// flag at the API edge.
export function can(session, flag) {
  if (!session) return false;
  if (session.role === 'admin') return true;
  return session.permissions?.[flag] !== false;
}
